import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ContactSearch from '../../../ContactSearch';
import getContactDisplay from '@afosto/utils/getContactDisplay';
import { contacts as contactsApi } from '@afosto/contacts/api/Contacts';

const ContactFilter = ({ onChange, operator, settings, suggestions, value, ...props }) => {
  const [contacts, setContacts] = useState([]);
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  });

  useEffect(() => {
    const initialValue = valueRef.current;

    const fetchContacts = async () => {
      try {
        const promises = initialValue.map(contactId => contactsApi.getContact(contactId));
        const results = await Promise.all(promises);

        const formattedContacts = results.reduce((acc, result) => {
          const contact = result?.data;

          if (contact) {
            return [...acc, { ...contact, label: getContactDisplay(contact), value: contact.id }];
          }

          return acc;
        }, []);

        setContacts(formattedContacts);
      } catch (err) {
        setContacts([]);
      }
    };

    if (initialValue && initialValue?.length > 0) {
      fetchContacts();
    }
  }, []);

  const handleChange = (ev, selectedContacts) => {
    setContacts(selectedContacts);

    if (onChange && typeof onChange === 'function') {
      onChange(
        ev,
        selectedContacts.map(selectedContact => selectedContact?.id),
      );
    }
  };

  return (
    <ContactSearch
      {...props}
      onChange={handleChange}
      value={contacts}
      multiple={!operator || ['in', 'not_in'].includes(operator)}
      enableCreate={false}
      validateContact={false}
    />
  );
};

ContactFilter.propTypes = {
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

ContactFilter.defaultProps = {
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default ContactFilter;
